import { Button, Col, Form, Input, Row } from "antd";
// import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ImageUrl } from "../../config/helpers";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import { RESET } from "../../config/constants/api";
import swal from "sweetalert";


const ForgotPassword1 = () => {
  const [form] = Form.useForm();
  // const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.user.userToken);
  const navigate = useNavigate();
  const onFinish = (values) => {
    Post(RESET.sendCode, { email: values.email, type: "ADMIN"}, token)
      .then((response) => {
        if (response.status) {
          form.resetFields();
          // Log verification code to console for debugging
          if (response.data?.verificationCode) {
            console.log("🔑 Verification Code:", response.data.verificationCode);
          }
          // Show code in alert for easy access during testing
          const code = response.data?.verificationCode || response.message?.split("Code: ")[1];
          if (code) {
            swal("Success", `Verification code sent! Code: ${code}`, "success");
          } else {
            swal("Success", response?.message, "success");
          }
          navigate("/forgotPassword/otp", { state: { email: values.email } });
        }
      })
      .catch((err) => {
        console.log("Error", err);
        swal("Error", err?.response?.data?.message, "error");
      });
  };
  // const onFinishFailed = (errorInfo) => {
  //   console.log("Failed:", errorInfo);
  // };
  return (
    <Row
      justify="center"
      style={{
        backgroundImage: `url('${ImageUrl("login.png")}')`, // Setting background color to black with 90% opacity
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="h-screen max-sm:pb-8"
      gutter={[16, 0]}
    >
      <Col
        xl={8}
        lg={7}
        md={6}
        sm={0}
        xs={0}
        className="flex justify-center items-end max-md:hidden"
      >
        <img src={ImageUrl("login-2.png")} alt=""/>
      </Col>
      <Col
        xl={8}
        lg={10}
        md={12}
        sm={20}
        xs={20}
        className=" items-center flex w-full"
      >
        <div
          className="flex flex-col justify-center items-center bg-white rounded-lg pb-8 px-8 max-lg:px-2 w-full pt-4"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <img src={ImageUrl("logo.png")} width={130} alt="logo" />
          <h3 className="mt-4 font-tavi text-3xl text-black max-md:text-xl">
            Forgot Password
          </h3>
          <p className="capitalize font-euclid text-sm text-[#34324B] mb-8 max-md:text-xs text-center">
            Enter your email to recover your password
          </p>
          <Form
            form={form}
            name="normal_login"
            onFinish={onFinish}
            layout="vertical"
            className="w-full px-8 max-xl:px-2"
          >
            <Row justify="center" gutter={[16, 16]}>
              <Col md={24} sm={24} xs={24}>
                <Form.Item
                  name="email"
                  label="Email Address"
                  rules={[
                    {
                      required: true,
                      message: "Please input your email address!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Email Address"
                    className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                    autoComplete={false}
                    type="email"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Col md={12}>
                <Form.Item className="self-center text-center">
                  <Button
                    htmlType="submit"
                    className="bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-black px-14 h-[50px] hover:text-customGold text-center text-sm"
                  >
                    {/* {loading ? "LOADING..." : "CONTINUE"} */}
                    CONTINUE
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Link
                to="/login"
                className="font-euclid text-black text-sm border-b-2 border-black font-semibold mt-4 hover:text-black"
              >
                Back to Sign In
              </Link>
            </Row>
          </Form>
        </div>
      </Col>
      <Col
        xl={8}
        lg={7}
        md={6}
        sm={0}
        xs={0}
        className="flex justify-center items-end max-md:hidden"
      >
        <img src={ImageUrl("login-1.png")} alt=""/>
      </Col>
    </Row>
  );
};

export default ForgotPassword1;
